import React from 'react';
import {default as PaymentSelector, paymentTypes} from './paymentInputs/PaymentSelector';
import {connect} from 'react-redux';
import {paymentProfiles} from '../../ducks/index';
import translatePaymentDetails from './translatePaymentDetails';

// This form sets up a payment profile.  Logic about "yeah I'd like to enroll in autopay" should be implemented by whichever component calls this one.
const mapStateToProps = (state, ownProps) => ({
  showSaveProfileOption: false, // In this context the user is specifically creating/updating a payment profile.  No need to prompt them.
  showAutopayOption: true
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  onSubmit: ({payment_method, token, account_id, autopay, paymentDetails, captureProfile = null}) => {

    // use `captureProfile` to retrieve the token if it's present
    const getToken = async () => {
      let result;
      if (captureProfile) {
        result = await captureProfile();
      } else {
        result = { token };
      }
      return result;
    };

    return getToken()
      .then(result => dispatch(paymentProfiles.actions.create(
        { ...translatePaymentDetails(payment_method, paymentDetails), autopay },
        { token: result.token, account_id }
      )))
      .then(paymentProfiles.actions.denormalizeObjects)
      .then((payment_profile) => Promise.resolve({ payment_profile }));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(PaymentSelector);
